export default __webpack_public_path__ + "static/media/IMG_2720.eea798fe.jpg";